import { render, staticRenderFns } from "./QRLoginForm.vue?vue&type=template&id=2554d563&scoped=true&"
import script from "./QRLoginForm.vue?vue&type=script&lang=ts&"
export * from "./QRLoginForm.vue?vue&type=script&lang=ts&"
import style0 from "./QRLoginForm.vue?vue&type=style&index=0&id=2554d563&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2554d563",
  null
  
)

export default component.exports